import React, { useState } from 'react';

import { useContentRequirementsContext } from 'src/application/features/RestrictNavigation/ContentRequirementsProvider';
import { useOnMount } from 'src/application/hooks/useOnMount';

import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { useContentBlocksContext } from '../../ContentBlocksContext';
import { useGetMultipleAssetUrls } from '../../hooks/useGetMultipleAssetUrls';
import { InteractiveWidgetBody } from '../_shared/InteractiveWidget/InteractiveWidgetBody/InteractiveWidgetBody';
import { InteractiveWidgetHeader } from '../_shared/InteractiveWidget/InteractiveWidgetHeader';
import { ExistingStudentWidgetProps } from '../Widget';
import { InteractiveTabsTab, InteractiveTabsWidget, WidgetType } from '@ael/core-api';

export const InteractiveTabsWidgetComponent: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const interactiveTabsWidget = widget as InteractiveTabsWidget;
  const widgetData = interactiveTabsWidget.value.data;
  const tabTitles = widgetData.tabs.map((x, index) => (x.title ? x.title : `Tab ${index + 1}`)); // temporary fix for tab header CSS workaround');

  const assetIds = widgetData.tabs.map((x) => x.assetId);

  const [selectedTabNumber, setSelectedTabNumber] = useState(0);
  const selectedTab: InteractiveTabsTab | null = widgetData.tabs[selectedTabNumber] ?? null;

  const { getAssetDataForIndex } = useGetMultipleAssetUrls(widget._id, WidgetType.interactiveTabs, assetIds);
  const getAssetUrlForSelectedTab = () => (selectedTab?.assetId ? getAssetDataForIndex(selectedTabNumber) : null);

  const { submitWidget, fulfilled } = useContentRequirementsContext();
  const [, setViewedTabs] = useState<boolean[]>(new Array(widgetData.tabs.length).fill(true, 0, 1).fill(false, 1));

  useOnMount(() => {
    if (fulfilled === false && interactiveTabsWidget.value.properties.isRequired && widgetData.tabs.length === 1) {
      submitWidget(widget, true);
    }
  });

  const setTab = (index: number) => {
    setSelectedTabNumber(index);

    if (fulfilled === false && interactiveTabsWidget.value.properties.isRequired)
      setViewedTabs((prev) => {
        const newViewedTabs = [...prev];
        newViewedTabs[index] = true;
        if (newViewedTabs.every((viewed) => viewed)) {
          submitWidget(widget, true);
        }
        return newViewedTabs;
      });
  };

  const { inSmallWindow } = useContentBlocksContext();

  return (
    <StudentWidgetWrapper>
      {tabTitles.length > 1 && (
        <InteractiveWidgetHeader
          currentTabIndex={selectedTabNumber}
          tabs={tabTitles}
          setCurrentTabNumber={setTab}
          displayTabSlider
        />
      )}
      <InteractiveWidgetBody
        key={selectedTabNumber}
        title={selectedTab?.title}
        text={selectedTab?.text ?? undefined}
        assetData={getAssetUrlForSelectedTab()}
        assetAlignment={selectedTab?.assetAlignment}
        inSmallWindow={inSmallWindow}
      />
    </StudentWidgetWrapper>
  );
};
